import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Axios interceptor: auto-redirect to login on 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/auth') {
      localStorage.removeItem('apexion_token');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

const getAuthHeaders = () => {
  const token = localStorage.getItem('apexion_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  // Generic request
  get: (url) => axios.get(`${API}${url}`, { headers: getAuthHeaders() }),
  post: (url, data) => axios.post(`${API}${url}`, data, { headers: getAuthHeaders() }),
  put: (url, data) => axios.put(`${API}${url}`, data, { headers: getAuthHeaders() }),
  delete: (url) => axios.delete(`${API}${url}`, { headers: getAuthHeaders() }),

  // Auth
  signup: (data) => axios.post(`${API}/auth/signup`, data),
  login: (data) => axios.post(`${API}/auth/login`, data),
  getMe: () => axios.get(`${API}/auth/me`, { headers: getAuthHeaders() }),

  // Subscription
  createCheckout: (tier) =>
    axios.post(
      `${API}/subscription/checkout`,
      { tier, origin_url: window.location.origin },
      { headers: getAuthHeaders() }
    ),
  checkPaymentStatus: (sessionId) =>
    axios.get(`${API}/subscription/status/${sessionId}`, { headers: getAuthHeaders() }),

  // Exchange
  connectExchange: (data) =>
    axios.post(`${API}/exchange/connect`, data, { headers: getAuthHeaders() }),
  getExchangeStatus: () => axios.get(`${API}/exchange/status`, { headers: getAuthHeaders() }),

  // Bots
  createBot: (data) => axios.post(`${API}/bots/create`, data, { headers: getAuthHeaders() }),
  getBots: () => axios.get(`${API}/bots`, { headers: getAuthHeaders() }),
  startBot: (botId) => axios.post(`${API}/bots/${botId}/start`, {}, { headers: getAuthHeaders() }),
  pauseBot: (botId) => axios.post(`${API}/bots/${botId}/pause`, {}, { headers: getAuthHeaders() }),
  stopBot: (botId) => axios.post(`${API}/bots/${botId}/stop`, {}, { headers: getAuthHeaders() }),
  killSwitch: () => axios.post(`${API}/bots/killswitch`, {}, { headers: getAuthHeaders() }),

  // Strategies
  getStrategies: () => axios.get(`${API}/strategies`),
  getStrategyDetails: (strategyId) => axios.get(`${API}/strategies/${strategyId}`),
  getTechnicalAnalysis: () => axios.get(`${API}/trading/technical-analysis`),

  // Notifications
  getNotificationSettings: () => axios.get(`${API}/notifications/settings`, { headers: getAuthHeaders() }),
  updateNotificationSettings: (settings) => axios.put(`${API}/notifications/settings`, settings, { headers: getAuthHeaders() }),
  sendTestNotification: () => axios.post(`${API}/notifications/test`, {}, { headers: getAuthHeaders() }),

  // Trading
  getMarketData: () => axios.get(`${API}/trading/market-data`),
  getTrades: () => axios.get(`${API}/trades`, { headers: getAuthHeaders() }),
  getDashboardStats: () => axios.get(`${API}/dashboard/stats`, { headers: getAuthHeaders() }),
  getEngineMetrics: () => axios.get(`${API}/trading/engine-metrics`, { headers: getAuthHeaders() }),
};

export default api;